import * as Msdyn365 from '@msdyn365-commerce/core';
import { ErrorCode } from '../modules/order-details';
import { ensureAuthenticated } from '../utilities/is-authenticated';

/**
 * GetBillingDocuments Input Action
 */
export class GetBillingDocumentsInput implements Msdyn365.IActionInput {
    public userToken: string;

    constructor(ctx: Msdyn365.ICreateActionContext) {
        this.userToken = ctx.requestContext.user.token;
    }

    public getCacheKey = () => `GetBillingDocuments-${this.userToken}`;
    public getCacheObjectType = () => 'GetBillingDocuments';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetBillingDocumentsData {
    value: ILxsBillingDocument[];
    BillingDocuments: ILxsBillingDocument[];
    error?: ErrorCode;
}

export interface IGetBillingDocumentsResponse {
    value: ILxsBillingDocument[];
    error?: ErrorCode;
}

export interface ILxsBillingDocument {
    DocumentId: string;
    BillingType: string;
    BillingTypeText?: string;
    BillingDate: string;
    SoldToId: string;
    SoldToName?: string;
    DueDate?: string;
    TotalAmount: number;
    NetAmount?: number;
    Tax?: number;
    Currency: string;
    References?: ILxsBillingReferences[];
    Highlight?: boolean;
    Document?: ILxsBillingDocumentData;
}

export interface ILxsBillingReferences {
    OrderNumber?: string;
    PurchaseOrderNumbExt?: string;
    ShipTo?: string;
    ShipToName?: string;
}

export interface ILxsBillingDocumentData {
    DocumentId: string;
    Type: string;
    Name: string;
    Reference: string;
    Date: string;
    FileSize: string;
    Language: string;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetBillingDocumentsInput(args);
};

async function action(_: GetBillingDocumentsInput, ctx: Msdyn365.IActionContext): Promise<IGetBillingDocumentsResponse> {
    ensureAuthenticated(ctx);
    const response = await Msdyn365.sendRequest<IGetBillingDocumentsData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/GetBillingDocuments(language='${ctx.requestContext.locale}')`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    );
    if (response.status === 200 && response.data) {
        return { value: response.data.BillingDocuments, error: { errorCode: response.status, errorText: response.statusText } };
    }

    return { ...({} as IGetBillingDocumentsData), error: { errorCode: response.status, errorText: response.statusText } };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetBillingDocumentsData>>action,
    id: 'GetBillingDocuments',
    input: createInput
});
